import React from 'react';;

import './styles.css'

//COMPONENTS
import Template from '../../components/Template';
import NotificationCard from '../../components/NotificationCard';


export default function NotificationPage() {

  return (
    <Template path={'Notificações'}>
      <div className='container'>
        <div className='col-md-12'>
          <div className='row justify-content-md-center'>
            <div className='col-md-8'>
              <div className="card-box">
                <div className="card-header">
                  <h1>Notificações</h1>
                </div>
                <div className="card-body notification-box">
                  <NotificationCard />
                  <NotificationCard />
                  <NotificationCard />
                  <NotificationCard />
                  <NotificationCard />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Template>
  )
}
